import { FC } from 'react';
import { useShallow } from 'zustand/react/shallow';

import usePlankTableStore from '../../hooks/usePlankTableStore';
import { getClaimsTotaal, getOpstartDate } from '../../utils/voorraadbeheer';

import { getVoorraadSeverity } from './voorraadSeverity';

import styles from './VoorraadbeheerTooltip.module.css';

const VoorraadbeheerTooltip: FC = () => {
  const show = usePlankTableStore(useShallow((state) => state.tooltip.show));
  const x = usePlankTableStore(useShallow((state) => state.tooltip.x));
  const y = usePlankTableStore(useShallow((state) => state.tooltip.y));
  const orientation = usePlankTableStore(useShallow((state) => state.tooltip.orientation));
  const orientationX = usePlankTableStore(useShallow((state) => state.tooltip.orientationX));
  const title = usePlankTableStore(useShallow((state) => state.tooltip.title));
  const aanwezig = usePlankTableStore(useShallow((state) => state.tooltip.aanwezig));
  const benodigd = usePlankTableStore(useShallow((state) => state.tooltip.benodigd));
  const nietInzetbaar = usePlankTableStore(useShallow((state) => state.tooltip.nietInzetbaar));
  const verwachtGereed = usePlankTableStore(useShallow((state) => state.tooltip.verwachtGereed));
  const overOfTekort = usePlankTableStore(useShallow((state) => state.tooltip.overOfTekort));
  const inzetten = usePlankTableStore(useShallow((state) => state.tooltip.inzetten));
  const claims = usePlankTableStore(useShallow((state) => state.tooltip.claims));
  const claimsCount = getClaimsTotaal(claims);
  const variant = getVoorraadSeverity(overOfTekort, claimsCount);
  // Oranje: zelfde getal als 'Beschikb. totaal'. Rood: tekort van alle (getoonde) claims samen.
  const beschikbaarClaims = variant === 'warning' ? overOfTekort : -claimsCount;
  const beschikbaarReizigersdienst = aanwezig - inzetten - nietInzetbaar;
  // 'Beschikb. claims' hoort bij de oranje categorie, en bij de rode categorie zolang er claims
  // zijn om af te trekken (anders heeft de regel geen betekenis).
  const showBeschikbaarClaims = variant === 'warning' || (variant === 'error' && claimsCount > 0);
  return (
    <>
      {show && (
        <div
          data-testid='voorraadbeheerTooltip'
          className={[styles.tooltip, styles?.[orientation], styles?.[orientationX]].join(' ')}
          style={{ top: `${y}px`, left: `${x}px` }}
        >
          <header>
            <div>
              <strong>{title}</strong>
            </div>
            <div>Opstart&nbsp;{getOpstartDate()}</div>
          </header>
          <footer>
            <div className={styles.row}>
              <div>Aanwezig:</div>
              <div>{aanwezig}</div>
            </div>
            <div className={styles.row}>
              <div>Benodigd:</div>
              <div>{benodigd}</div>
            </div>
            <div className={[styles.row, styles.claim].join(' ')}>
              <div>Reizigersdienst:</div>
              <div>{inzetten}</div>
            </div>
            {Object.entries(claims)
              .toSorted((claimA, claimB) => String(claimA[0]).localeCompare(String(claimB[0])))
              .map(([claimsoort, aantal]) => (
                <div key={claimsoort} className={[styles.row, styles.claim].join(' ')}>
                  <div>{claimsoort}</div>
                  <div>{aantal}</div>
                </div>
              ))}
            <div className={styles.row}>
              <div>Verwacht niet inzetbaar:</div>
              <div>{nietInzetbaar}</div>
            </div>
            <div className={styles.row}>
              <div>Verwacht gereed:</div>
              <div>{verwachtGereed}</div>
            </div>
            <div className={styles.availabilitySection}>
              {showBeschikbaarClaims && (
                <div className={[styles.row, styles.availableClaims].join(' ')}>
                  <div>Beschikb. claims:</div>
                  <div>{beschikbaarClaims}</div>
                </div>
              )}
              {variant === 'error' && (
                <div className={[styles.row, styles.availablePassengerService].join(' ')}>
                  <div>Beschikb. r.dienst:</div>
                  <div>{beschikbaarReizigersdienst}</div>
                </div>
              )}
              <div className={[styles.row, styles.availableTotal].join(' ')}>
                <div>Beschikb. totaal:</div>
                <div>{overOfTekort}</div>
              </div>
            </div>
          </footer>
        </div>
      )}
    </>
  );
};
export default VoorraadbeheerTooltip;
